<div>
  <div class="center">
    {{screenName}}
  </div>

  <div class="left">
    <ppl-top-navigation-button [pplPopover]="popoverAppSwitcher"
                               pplPopoverAlignEnd>
      <ppl-icon svgIcon="app-switcher"
                width="18px"
                height="18px"></ppl-icon>
    </ppl-top-navigation-button>
    <ng-template #popoverAppSwitcher
                 let-position="position">
      <ppl-popover-window [position]="position"
                          style="margin-left: 5px">
        <ppl-top-navigation-app-switcher></ppl-top-navigation-app-switcher>
      </ppl-popover-window>
    </ng-template>

    <a [routerLink]="['/', { outlets: { about: ['about', { identity: 'coevera' }] } }]"
       class="logo">
      <ppl-icon width="92px"
                height="30px"
                svgIcon="logo-coevera-white"></ppl-icon>
    </a>
  </div>

  <div class="right">
    <ppl-top-navigation-button [pplPopover]="popoverUserMenu"
                               pplPopoverAlignEnd>
      <ng-container *ngIf="(loggedInUser$ | async).profile; let profile; else noProfile">
        <div class="avatar">
          <img *ngIf="profile.pictureUrl; else noProfile"
               [src]="profile.pictureUrl"
               alt="" />
        </div>
      </ng-container>
      <ng-template #noProfile>
        <ppl-icon svgIcon="my-account-topnavigation"
                  width="18px"
                  height="18px"></ppl-icon>
      </ng-template>
    </ppl-top-navigation-button>
    <ng-template #popoverUserMenu
                 let-position="position">
      <ppl-popover-window [position]="position">
        <ppl-top-navigation-user-menu userSettingsRouterLink="/user/edit"
                                      [userProfile]="(loggedInUser$ | async).profile">
        </ppl-top-navigation-user-menu>
      </ppl-popover-window>
    </ng-template>
  </div>
</div>
